import React, { ChangeEventHandler, FocusEventHandler } from "react";

import { useFormData } from "@sp-state/useFormData";
import InputWrapper from "../InputWrapper";
import Input from "../Input";

const FirstNameInput = () => {
  const { firstName, setError, setValue, setIsValid } = useFormData(
    state => state
  );
  const INPUT_NAME = "firstName";

  const onBlur: FocusEventHandler<HTMLInputElement> = e => {
    if (e.target.value.length < 1) {
      setError(INPUT_NAME, true);
      setIsValid(INPUT_NAME, false);
    }
  };

  const onChange: ChangeEventHandler<HTMLInputElement> = e => {
    const { value } = e.target;

    if (firstName.hasError) setError(INPUT_NAME, false);
    if (value.length >= 1) setIsValid(INPUT_NAME, true);

    setValue(INPUT_NAME, value);
  };

  return (
    <InputWrapper
      errorMsg="This field is required."
      hasError={firstName.hasError}
      label="First Name"
    >
      <Input
        hasError={firstName.hasError}
        isValid={firstName.isValid}
        onBlur={onBlur}
        onChange={onChange}
        value={firstName.value}
        name="given-name"
        autoComplete="given-name"
      />
    </InputWrapper>
  );
};

export default FirstNameInput;
